import React,{ ReactNode, createContext, useContext, useState } from "react";

// type Preferences = {
//   audioMode: "normal" | "fixed";
// };

// type PreferencesContextProps = {
//   preferences: Preferences;
//   setPreferences: (newPreferences: Partial<Preferences>) => void;
// };
const PreferencesContext = createContext(null);

export const PreferencesProvider = ({ children }) => {
  const [preferences, setPreferences] = useState({ audioMode: "fixed"});

  const onChangePreferences = (newPreferences) => {
    setPreferences((prev) => ({ ...prev, ...newPreferences }));
  };

  return (
    <PreferencesContext.Provider
      value={{
        preferences,
        setPreferences: onChangePreferences,
      }}
    >
      {children}
    </PreferencesContext.Provider>
  );
};

export const usePreferencesContext = () => useContext(PreferencesContext);
